module.exports = __webpack_public_path__ + "static/media/video.b2f04936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BusinessNews/video.jpg
// module id = 273
// module chunks = 0